var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"systemDialog"}},[_c('div',[_c('div',{staticClass:"systemDialogTitle"},[_vm._v("401 Unauthorized")]),_c('div',{staticClass:"systemDialogText"},[_vm._v("セッションが切れました。再度ログインしてください。")]),_c('button',{on:{"click":function($event){return _vm.toSignIn()}}},[_vm._v("ログインページへ戻る")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }